import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { api, mediaUrl } from "@/lib/api";
import { Reveal } from "./Reveal";

const Card = ({ src }) => (
  <div className="mx-2 sm:mx-3 h-48 sm:h-64 overflow-hidden rounded-2xl glass p-1.5">
    <img src={mediaUrl(src)} alt="Un fan insieme alle Cosplay Singers a un concerto" loading="lazy" className="h-full w-auto rounded-xl object-cover" />
  </div>
);

export const Fans = () => {
  const [photos, setPhotos] = useState(null);

  useEffect(() => {
    api.get("/photos?section=fans").then((r) => setPhotos(r.data)).catch(() => setPhotos([]));
  }, []);

  if (photos && photos.length === 0) return null;

  const list = photos || [];
  const rowA = list.filter((_, i) => i % 2 === 0);
  const rowB = list.filter((_, i) => i % 2 === 1);
  const secondRow = rowB.length ? rowB : rowA;

  return (
    <section id="fan" data-testid="fans" className="overflow-hidden py-20 sm:py-28">
      <Reveal className="mb-12 px-5 text-center sm:px-8 lg:px-12">
        <p className="mb-4 text-xs uppercase tracking-[0.3em] text-lavender-deep">Insieme a voi</p>
        <h2 className="font-serif tracking-tightest text-4xl sm:text-6xl leading-[1.0] text-navy">
          Voi siete lo <span className="italic text-lavender-deep">spettacolo.</span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg text-navy-soft">
          I volti, gli abbracci e i sorrisi di chi rende ogni data indimenticabile.
        </p>
      </Reveal>

      <div className="space-y-3 sm:space-y-4">
        <Marquee autoFill pauseOnHover speed={38} gradient gradientColor="#FCFBFF" gradientWidth={90}>
          {rowA.map((p) => (
            <Card key={p.id} src={p.src} />
          ))}
        </Marquee>
        <Marquee autoFill pauseOnHover direction="right" speed={38} gradient gradientColor="#FCFBFF" gradientWidth={90}>
          {secondRow.map((p) => (
            <Card key={p.id} src={p.src} />
          ))}
        </Marquee>
      </div>
    </section>
  );
};
